export default "__VITE_ASSET__CfOXe2fm__"